
@import "~animatewithsass/animate.scss";

.multi-select-checkbox-dropdown {
  position: relative;
  width: 100%;

  .multi-select-checkbox-btn {
    width: 100%;
    text-align: left;
    background: linear-gradient(0deg, #6A7B89, #899AA6) !important;
    color: #FDFEFE;
    border: none !important;
    outline: none !important;
    box-shadow: 0 3px 2px 0 black;
    font-weight: 100;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .selected-options {
      display: flex;
      flex-wrap: wrap;
      gap: 2px;
      .selected-option {
        padding: 7px;
        margin: 5px;
        background-color: #dcdddf;
        border-radius: 5%;
        color: #161c1f;
        .deselect-option {
          z-index: 5;
          padding: 5px;
          background-color: #6e7f8d;
          border-radius: 50%;
          margin-left: 5px;
        }
      }
    }

    .caret {
      float: right;

      .icon-caret {
        border-style: solid;
        height: 0;
        width: 0;
        display: inline-block;
      }

      .icon-caret-up {
        border-color: white transparent transparent !important;
        border-width: 8px 7px 1.5px !important;
      }

      .icon-caret-down {
        border-color: transparent transparent white !important;
        border-width: 0 7px 7px !important;
      }
    }
  }

  .multi-select-checkbox-menu {
    z-index: 1;
    width: 100%;
    list-style-type: none;
    padding: 0;
    position: absolute;
    max-height: 200px;
    overflow: auto;
    margin-bottom: 0;
    bottom: 100%;
    margin-top: 10px;
    background-color: #2C495D;
    color: white;
    border-radius: 5px;

    li {
      border-radius: 5px;
      display: flex;
      padding: 5px 7px;

      &:hover {
        background-color: #5A6E7E;
      }

      .option-text {
        vertical-align: middle;
        width: 100%;
        cursor: pointer;
      }

      .icon-check {
        cursor: pointer;
        vertical-align: middle;
        padding-right: 7px;
        float: right;

        img {
          height: 20px;
          border: 1px solid;
          padding: 4px;
          border-radius: 12px;
        }
      }
    }

    .option-disabled {
      opacity: .3;
    }
  }

  .dropdown-show {
    @include fadeInDown();
  }

  .dropdown-hide {
    @include fadeOutUp();
    visibility: hidden;
    overflow: hidden;
    transition: visibility 1s ease;
  }

  .dropdown-hide {
    display: none;
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/multi-select/multi-select.scss